import {
  AccountingPlatformPaymentAccount,
  apiClient,
  PostAccountingPlatformPaymentAccountRequest,
} from '@melio/javascript-sdk';

import { useCollectionApi } from '../../core';
import { useCreateMutation } from '../../core/useCreateMutation';
import { AccountingPlatformPaymentAccountCollection, UseAccountingPlatformPaymentAccountsProps } from './types';

export const useAccountingPlatformPaymentAccounts = (
  props: UseAccountingPlatformPaymentAccountsProps
): AccountingPlatformPaymentAccountCollection => {
  const client = apiClient.accountingPlatformsPaymentAccounts(props.accountingPlatformId);

  const query = useCollectionApi<AccountingPlatformPaymentAccount, PostAccountingPlatformPaymentAccountRequest>({
    ...props,
    queryKey: ['accounting-platform', props.accountingPlatformId, 'payment-accounts'],
    queryFn: () => client.fetch(),
  });

  const create = useCreateMutation(client.create, query);

  return {
    ...query,
    create,
  };
};
